import MissingRatingNameModal from './MissingRatingNameModal'

export default MissingRatingNameModal
